import { UserData } from './user-data.interface';
import { userDataFromDomFactory } from './util';

export const userData: UserData = userDataFromDomFactory();
